import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared layout for legal pages (Terms, Privacy). Renders a max-width prose column
 * over the brand peach background with a back-to-home link. Content is passed as JSX
 * children so each legal page just focuses on its copy.
 */
export default function LegalPageShell({ title, effectiveDate, children, testId }) {
  return (
    <div className="min-h-screen py-10 px-4" style={{ background: "#FFF7ED" }} data-testid={testId}>
      <div className="max-w-3xl mx-auto">
        <Link
          to="/home"
          className="inline-flex items-center gap-1.5 text-sm font-bold mb-6"
          style={{ color: "#13A699" }}
          data-testid="legal-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="bg-white rounded-3xl p-6 sm:p-10 border border-black/5 shadow-sm">
          <h1
            className="font-display text-3xl sm:text-4xl font-bold uppercase"
            style={{ color: "#13A699" }}
            data-testid="legal-title"
          >
            {title}
          </h1>
          <p className="mt-1 text-xs" style={{ color: "#13A69999" }} data-testid="legal-effective-date">
            Effective date: {effectiveDate}
          </p>

          <div
            className="mt-6 space-y-5 text-sm leading-relaxed"
            style={{ color: "#13A699" }}
            data-testid="legal-body"
          >
            {children}
          </div>

          <div className="mt-10 pt-6 border-t border-black/10 flex items-center gap-4 text-xs" style={{ color: "#13A69999" }}>
            <Link to="/terms" className="hover:underline" data-testid="legal-footer-terms">
              Terms &amp; Conditions
            </Link>
            <span>·</span>
            <Link to="/privacy" className="hover:underline" data-testid="legal-footer-privacy">
              Privacy Policy
            </Link>
            <span>·</span>
            <a href="mailto:admin@rateed.com" className="hover:underline" data-testid="legal-footer-contact">
              admin@rateed.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
